var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * CZNA-1449 — the ⋮ menu in the header of one occurrence of a repeatable field:
 * the actions over that whole occurrence. Today "Odebrat výskyt", which used to
 * be a trash button of its own in the header.
 *
 * <p>Same Stripes `Dropdown` shape as the subfield row's ⋮ (`SubfieldRowMenu`),
 * and the same trap with `onToggle` — see there.
 */
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, Dropdown, DropdownMenu, IconButton } from '@folio/stripes/components';
import dropdownTriggerFocus from '../../../utils/dropdownTriggerFocus';
var FieldInstanceMenu = function (_a) {
    var id = _a.id, label = _a.label, onRemove = _a.onRemove;
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    return (React.createElement(Dropdown, { id: "".concat(id, "-dropdown"), open: open, onToggle: function () { return setOpen(!open); }, placement: "bottom-end", renderTrigger: function (_a) {
            var getTriggerProps = _a.getTriggerProps, triggerRef = _a.triggerRef, onToggle = _a.onToggle, ariaProps = _a.ariaProps, keyHandler = _a.keyHandler;
            return (React.createElement(IconButton, __assign({ ref: triggerRef, id: id, icon: "ellipsis", size: "small", onClick: onToggle, onKeyDown: keyHandler }, dropdownTriggerFocus(getTriggerProps), { "aria-label": label }, ariaProps, { 
                // Popdown's `aria-expanded` is a boolean, which IconButton drops when false.
                ariaExpanded: String(open) })));
        } },
        React.createElement(DropdownMenu, { "aria-label": label, open: open, onToggle: function () { return setOpen(false); } },
            React.createElement("div", { role: "menu" },
                React.createElement(Button, { buttonStyle: "dropdownItem", role: "menuitem", onClick: function () {
                        setOpen(false);
                        onRemove();
                    } },
                    React.createElement(FormattedMessage, { id: "ui-czna-authorities.proposalForm.fieldInstance.remove" }))))));
};
export default FieldInstanceMenu;
